/**
 * @export
 * @method curve
 * @param {String} position position
 * @param {String} color color
 * @param {String} cssClass class
 * @returns {String} position
 */
function curve(position, color, cssClass) {
  const curvePosition = typeof position === 'string' && position ? position : 'both';
  const fillColor = typeof color === 'string' && color ? color : '#fff';
  const cssClassString = typeof cssClass === 'string' && cssClass ? cssClass : '';
  const positions = {
    top: `
        <svg focusable="false" class="curve-top ${cssClassString}" viewBox="0 0 1400 38" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          <path d="M 0 38 L 0 0 L 1400 0.121 C 1346.561 0.952 1159.562 3.294 1106.153 3.435 C 1088.943 3.481 1071.736 3.614 1054.531 3.833 C 972.139 4.896 889.72 6.585 807.317 8.093 C 724.914 9.6 642.556 11.243 560.165 13.659 C 524.467 14.706 488.635 15.911 452.924 16.757 C 371.192 18.694 289.508 21.909 207.863 26.028 C 182.189 27.311 156.519 28.657 130.851 30.061" shape-rendering="geometricPrecision" style="fill:${fillColor};"/>
        </svg>
      `,
    bottom: `
        <svg focusable="false" class="curve-bottom ${cssClassString}" viewBox="0 0 1400 38" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          <path d="M 48.179 34.027 C 77.767 32.124 107.361 30.31 136.961 28.583 C 246.195 22.388 355.479 17.949 464.832 14.561 C 574.238 11.173 683.657 8.376 793.092 6.173 C 902.831 3.852 1012.542 2.507 1122.299 1.45 C 1214.873 1.45 1307.424 0 1400 0 L 1400 37.953 C 1400 37.953 48.802 38.011 0 38" shape-rendering="geometricPrecision" style="fill: ${fillColor};"/>
        </svg>
      `
  };
  return position === 'both' ? positions.top + positions.bottom : positions[curvePosition];
}

/**
 * @exports
 * @method codeFriendly
 * @param {String} string string
 * @returns {String} string
 */
function codeFriendly(string) {
  return string.toLowerCase().replace(/<\/?[^>]*>/g, ' ').replace(/\s+/g, '-').replace(/(?:&\w+;|[^a-z0-9])/gi, '');
}

/**
 * @exports
 * @method attrFriendly
 * @param {String} string string
 * @returns {String} string
 */
function attrFriendly(string) {
  return string.replace(/<\/?[^>]*>/g, ' ').replace('&nbsp;', ' ').replace(/\s+/gi, ' ');
}

// eslint-disable-next-line no-confusing-arrow
const isArray = (a, opts) => Array.isArray(a) ? opts.fn(undefined) : opts.inverse(undefined);

export { attrFriendly, codeFriendly, curve, isArray };
